<template src="./About.component.html"></template>
<style type="text/css" src="./About.component.css"></style>

<script>
export default {
  name: 'About',
  data () {
    return {
    	showScrollBar: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/About/About.component.vue